// /labs/genui/$id — REDIRECT, not a ported page. Same rationale as
// routes/labs-genui.tsx: the old per-session lab page
// (app/labs/genui/[id]/page.tsx) just mounted `<GenUIChat sessionId={id}/>`,
// which is exactly what '/chat/$sessionId' renders today (routes/index.tsx
// + routes/chat.$sessionId.tsx share the one GenUIChat instance off
// chat-shell.tsx). Redirects straight to the equivalent `/chat/$id` URL
// instead of re-mounting a second instance. Kept under `_authed` — same
// scoping as the placeholder this replaces (routes/agents.tsx). Registered
// from routes/agents.tsx.
import { createRoute, redirect } from '@tanstack/react-router';
import { authedRoute } from './guards';

export const labsGenuiDetailRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/labs/genui/$id',
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/chat/${encodeURIComponent(params.id)}` });
  },
});
